<template>
  <div id="nav">
    <a-page-header
      title="页面模版选择"
      sub-title="选择内置页面模版（内置业务组件）"
    />
    <a-layout-content
      style="padding: 20px; display: flex; flex: 1}"
    >
      <PageSelector/>
    </a-layout-content>
  </div>
  <!--<router-view/>-->
</template>

<script>
import PageSelector from './views/pageSelector/Index.vue'
export default {
  name: 'App',
  methods: {},
  components: {
    PageSelector
  }
}
</script>

<style lang="scss">
#nav {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  /*background: #3e3e40;*/
}
</style>
